import CRUD from 'src/store/models/helper/CRUD.js'
import Timetable from 'src/api/timetable.js'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export class Holiday extends CRUD {
  static entity = 'holidays'
  static fetchUrl = Timetable.timetableHolidaysUrl()

  static fields () {
    return {
      id: this.attr(null),
      name: this.string(''),
      shortcut: this.string(''),
      begins_at: this.number(GlobalPrototypes.moment().unix()),
      ends_at: this.number(GlobalPrototypes.moment().add(1, 'days').unix()),
      meta: this.attr({ displayname: null })
    }
  }
}

export default Holiday
